import gsap from 'gsap'
import Lenis from 'lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { isSafariBrowser } from './utilities.js'

gsap.registerPlugin(ScrollTrigger)

export let lenis, scrollToStart

export const initLenis = () => {

  lenis = new Lenis({
		smoothWheel: !isSafariBrowser(),
		anchors: {
			offset: -100,
			duration: 1.8
		}
  })

	if (isSafariBrowser()) {
		document.documentElement.classList.add('is-safari')
	}

	lenis.on('scroll', ScrollTrigger.update);

	let lastScrolled = null
	let lastDirection = null

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000)

		const scrolled = lenis.scroll > 50
		if (scrolled !== lastScrolled) {
			document.documentElement.dataset.scrolled = scrolled
			lastScrolled = scrolled
		}

		const direction = (lenis.direction == 1 && lenis.scroll > 0) ? 'forward' : 'backward'
		if (direction !== lastDirection) {
			document.documentElement.dataset.direction = direction
			lastDirection = direction
		}
	})

}

scrollToStart = () => {
  lenis.scrollTo(0, { immediate: true })
}